import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SEO = ({ title, description, path, jsonLd = [] }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", "Savannah's House");
    setMeta("property", "og:image", `${origin}/images/living1-1600.webp`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", `${origin}/images/living1-1600.webp`);
    setMeta("name", "robots", "index, follow");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    jsonLd.forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });

    return () => {
      document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    };
  }, [title, description, path, jsonLd]);

  return null;
};

export const orgJsonLd = (origin) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${origin}/#business`,
  name: "Savannah's House",
  slogan: "A Safe Place to Call Home. A Family You Can Trust.",
  description:
    "Savannah's House is a warm, supportive residential home in Tyler, Texas serving seniors, veterans, and adults seeking a smaller, more personal place to call home.",
  url: origin,
  telephone: "+1-903-202-4950",
  email: "info@savannahshouse.org",
  sameAs: ["https://www.facebook.com/profile.php?id=61594235575681"],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Tyler",
    addressRegion: "TX",
    addressCountry: "US",
  },
  areaServed: [
    { "@type": "City", name: "Tyler, Texas" },
    { "@type": "AdministrativeArea", name: "East Texas" },
  ],
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "09:00",
    closes: "17:00",
  },
});

export const websiteJsonLd = (origin) => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Savannah's House",
  url: origin,
});

export const webPageJsonLd = (origin, path, name, description) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name,
  description,
  url: `${origin}${path}`,
  isPartOf: { "@type": "WebSite", name: "Savannah's House", url: origin },
});

export const breadcrumbJsonLd = (origin, items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${origin}${item.path}`,
  })),
});
